import { DestroyRef, Directive, EffectRef, effect, inject, Injector, input, runInInjectionContext, untracked } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[maxValue]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxValueValidatorDirective, multi: true }],
    standalone: true
})

export class MaxValueValidatorDirective implements Validator {
    readonly maxValue = input<number | Date>(undefined);

    private readonly destroyRef = inject(DestroyRef);
    private readonly injector = inject(Injector);
    private validatorDepsEffect?: EffectRef;

    constructor() {
        this.destroyRef.onDestroy(() => this.validatorDepsEffect?.destroy());
    }

    registerOnValidatorChange(fn: () => void): void {
        this.validatorDepsEffect?.destroy();
        runInInjectionContext(this.injector, () => {
            this.validatorDepsEffect = effect(() => {
                this.maxValue();
                untracked(() => fn());
            });
        });
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const controlValueExists: boolean = control.value !== null && control.value !== undefined;
        const maxValue = this.maxValue();
        const maxValueProvided: boolean = maxValue !== null && maxValue !== undefined;
        const error: ValidationErrors = controlValueExists && maxValueProvided && control.value > this.maxValue()
            ? { "max": `Number cannot be more than ${this.maxValue()}` }
            : null;
        return error;
    }
}
